export default function Spinner() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 backdrop-blur-sm">
      <div className="w-12 h-12 border-4 border-red-600 border-solid rounded-full animate-spin border-t-transparent"></div>
    </div>
  );
}
